import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom"; //React route//GifLoader
import { Typography, Box } from "@mui/material"; //Se importan elementos de la librería material-ui
import Parser from "html-react-parser";

import {
  fileActions,
  workflowActions,
  addTitleLegoCurrent,
} from "../../store/actions"; //Acciones para redux
import {
  UseImage,
  CustomAlertMaterial,
  CustomLoadingOverlay,
  GenericContainer,
  GenericContainerForm,
  GenericContainerImage,
  Buttons,
  Alert,
} from "../../components";
import { useStyles } from "./InformationalMessageFormStyles"; //Métodos de éste componente (no requieren state)
import { coreFunctions } from "../../utils"; //funciones del nucleo
import ic_informativo_vectorImg from "../../assets/ic_informativo_vector.png";
import ic_aceptacionImg from "../../assets/ic_aceptacion.jpg";
import ic_payment_registrationImg from "../../assets/ic_payment_registration.jpg";
import ic_register_validationImg from "../../assets/ic_register_validation.jpg";
import ic_registroNoEncontradoImg from "../../assets/ic_registroNoEncontrado.jpg";
import ic_nuevos_usuariosImg from "../../assets/ic_nuevos_usuarios.jpg";
import ic_registroEncontradoImg from "../../assets/ic_registroEncontrado.jpg";
import ic_person_conferenceImg from "../../assets/ic_person_conference.jpg";
import { useTranslation } from "react-i18next";
import { ClearSession } from "../../utils";

export default function InformationalMessageFormComponent(props) {
  const location = useLocation();
  const localStyles = useStyles();
  const [loadView, setLoadView] = useState(false); //Se muestra/oculta el gif loader
  const [stateActual, setStateActual] = useState("");
  const navigate = useNavigate(); //Módulo "History" de react router

  //Estados de componente
  const [logoutOnSave, setLogoutOnSave] = useState("");
  const [titleText, setTitleText] = useState("");
  const [textDescription, setDescription] = useState("");
  const [performLogout, setPerformLogout] = useState(0);
  const [allowCancelFlow, setAllowCancelFlow] = useState(0);
  const [goToDashboard, setGoToDashboard] = useState(0);
  const [iconRefValue, setIconRefValue] = useState("");
  const [cancelAction, setCancelAction] = useState(false);
  const [continueAction, setContinueAction] = useState(false);
  const [timerSeconds, setTimerSeconds] = useState(20);
  const [activeFileInfo, setActiveFileInfo] = useState(false);
  const [fileId, setFileId] = useState(0);
  const [activaContinueButton, setActivaContinueButton] = useState(0);
  const [activeCargaInicial, setActiveCargaInicial] = useState(false);
  const [showAlertMaterial, setShowAlertMaterial] = useState(false);
  const [statusFileInfo, setStatusFileInfo] = useState("");

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const wf = useSelector((state) => state.Workflow);
  const file = useSelector((state) => state.FileInfo);
  const cancelWF = useSelector((state) => state.CancelWorkFlow);
  const continueWF = useSelector((state) => state.ContinueWorkflow);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  //Promesa general Init
  useEffect(() => {
    dispatch(addTitleLegoCurrent(""));
    //Ancho de los botones
    // if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) {
    //     //Sí es móvil
    //     setWidthButton(100)
    // } else {
    //     //Sí es desktop
    //     setWidthButton(100)
    // }
    // if (!stateActualActivo) {
    setFileId(location.state.folioId);
    // console.log("STate actual inicio: ", location.state.Name)
    setStateActual(location.state.Name);
    // console.log("State actual: ", file.items.Stage.Name)
    // console.log("location.state: ", location.state)
    let fileId = location.state.folioId;
    // console.log("Folio ID: ", fileId)
    dispatch(fileActions.GetFileInfo(fileId));
    setActiveCargaInicial(true);

    let stateStage = location.state.stage.Stage;
    // console.log("state actual Stage--", stateStage)
    if (stateStage != undefined && stateStage != null) {
      let title = stateStage.Properties.find(
        (element) => element.Name == "TitleData"
      );
      let description = stateStage.Properties.find(
        (element) => element.Name == "TextData"
      );
      let buttonData = stateStage.Properties.find(
        (element) => element.Name == "ButtonData"
      );
      let performLogout = stateStage.Properties.find(
        (element) => element.Name == "PerformLogout"
      );
      let allowCancelFlow = stateStage.Properties.find(
        (element) => element.Name == "AllowCancelFlow"
      );
      let goToDashboard = stateStage.Properties.find(
        (element) => element.Name == "GoToDashboard"
      );
      let iconRef = stateStage.Properties.find(
        (element) => element.Name == "IconRef"
      );
      let ativateContButton = stateStage.Properties.find(
        (element) => element.Name == "ActivateContinueButton"
      );
      let LogoutOnSave = file.items?.Stage?.Properties?.find(
        ({ Name }) => Name === "LogoutOnSave"
      )?.Value;
      setLogoutOnSave(LogoutOnSave);
      setFileId(fileId);
      // setTitleText(title?.Value)
      dispatch(addTitleLegoCurrent(title?.Value));
      setDescription(description?.Value);
      setPerformLogout(performLogout?.Value);
      setAllowCancelFlow(allowCancelFlow?.Value);
      setGoToDashboard(goToDashboard?.Value);
      setIconRefValue(
        iconRef?.Value == "ic_gif_folder"
          ? iconRef?.Value?.toString()?.concat(".gif")
          : iconRef?.Value?.toString()?.concat(".jpg")
      );
      // console.log('Active button value', ativateContButton?.Value)
      setActivaContinueButton(
        ativateContButton?.Value === undefined ? true : ativateContButton.Value
      );
      setTimerSeconds(
        ativateContButton?.Value == undefined ||
          ativateContButton?.Value == false
          ? 25
          : -1
      );
      // } else {
      setActiveCargaInicial(true);
      // }
      // setStateActualActivo(true)
    }
  }, []);

  useEffect(() => {
    if (timerSeconds == -4000000000000) {
      //Realiza la peticion
      setTimerSeconds(25);
      setActiveFileInfo(true);
      setActiveCargaInicial(true);
      // console.log("Realiza peticion nueva File Info: ")
      dispatch(fileActions.GetFileInfo(fileId));
    }
    // salir cuando lleguemos a 0
    if (!timerSeconds) return;

    // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
    const intervalId = setInterval(() => {
      setTimerSeconds(timerSeconds - 1);
    }, 1000);

    // clear interval al volver a renderizar para evitar pérdidas de memoria
    return () => clearInterval(intervalId);
  }, [timerSeconds]);

  // useEffect(() => {
  //     // console.log("stageProps: ", stageProps)
  //     if (stageProps != undefined && stageProps != 0) {
  //         setCurrentStage(stageProps.CurrentStageGroup)
  //         setTotalStage(stageProps.TotalStageGroups)
  //     }
  // }, [stageProps])

  // useEffect(() => {
  //     let stageName = location.state.stageName
  //     let stageId = location.state.stageId
  //     // setNameStage(stageName)
  //     // console.log("location.state: ", location.state)
  //     // console.log("wf.items", wf.items)
  //     if (wf.items != undefined) {
  //         let items = wf.items
  //         items.forEach(i => {
  //             let stages = i.Stages
  //             let stgPrp = stages.find(j => j.Id === stageId && j.Name === stageName)
  //             setStageProps(stgPrp)
  //         });
  //     }
  // }, [wf])

  //Obtener valores de persistencia de datos y mostrarlos en interfaz
  useEffect(() => {
    setLoadView(file.loading);
    //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
    if (file.items != undefined && activeCargaInicial) {
      // console.log('FileInfo--Stage: ', file.items.Stage)
      let title = file.items.Stage.Properties.find(
        (element) => element.Name == "TitleData"
      );
      let description = file.items.Stage.Properties.find(
        (element) => element.Name == "TextData"
      );
      let buttonData = file.items.Stage.Properties.find(
        (element) => element.Name == "ButtonData"
      );
      let performLogout = file.items.Stage.Properties.find(
        (element) => element.Name == "PerformLogout"
      );
      let allowCancelFlow = file.items.Stage.Properties.find(
        (element) => element.Name == "AllowCancelFlow"
      );
      let goToDashboard = file.items.Stage.Properties.find(
        (element) => element.Name == "GoToDashboard"
      );
      let iconRef = file.items.Stage.Properties.find(
        (element) => element.Name == "IconRef"
      );
      let ativateContButton = file.items.Stage.Properties.find(
        (element) => element.Name == "ActivateContinueButton"
      );
      let LogoutOnSave = file.items?.Stage?.Properties?.find(
        ({ Name }) => Name === "LogoutOnSave"
      )?.Value;
      setLogoutOnSave(LogoutOnSave);
      setStatusFileInfo(file.items.Status);
      // console.log('FileInfo--Stage--iconRef: ', iconRef)
      // console.log('FileInfo--Stage--iconRef--VALUE: ', iconRef?.Value)
      // console.log("primeravez", { title, description, buttonData, performLogout })
      setFileId(file.items.Id);
      // setTitleText(title?.Value)
      dispatch(addTitleLegoCurrent(title?.Value));

      setDescription(description?.Value);
      setPerformLogout(performLogout?.Value);
      setAllowCancelFlow(allowCancelFlow?.Value);
      setGoToDashboard(goToDashboard?.Value);
      setIconRefValue(
        iconRef?.Value == "ic_gif_folder"
          ? iconRef?.Value?.toString()?.concat(".gif")
          : iconRef?.Value?.toString()?.concat(".jpg")
      );
      setActivaContinueButton(
        ativateContButton?.Value === undefined ? true : ativateContButton.Value
      );
      setTimerSeconds(
        ativateContButton?.Value == undefined ||
          ativateContButton?.Value == false
          ? 25
          : -1
      );
      // console.log('IconREF pantalla ', iconRef.Value)
      // setFileDate(file.items.CreationDate)
      // setFileCode(file.items.Folio)
      // console.log("stateActual: ", stateActual)
      // console.log("State consulta: ", file.items.Stage.Name)
      if (activeFileInfo && stateActual != file.items.Stage.Name) {
        if (goToDashboard == 1 || goToDashboard == "1") {
          navigate("/SearchResultComponent");
        } else if (performLogout == 1) {
          navigate("/auth/");
        } else if (logoutOnSave && logoutOnSave == "1") {
          //Logout y redireccion a login
          console.log("LogoutOnSave::clearsesion");
          Alert(
            {
              icon: "success",
              text: t("proccess_request"),
              okbtntext: t("general_accept"),
            },
            () => {
              ClearSession();
              navigate("/auth/");
            }
          );
        } else {
          let nextStage = file.items.Stage;
          let stageName = nextStage.Name;
          let stageId = nextStage.Id;
          let folioId = file.items.Id;
          let stage = file.items;
          // console.log("Activa stage siguiente stateActual: ", stateActual)
          // console.log("Activa stage siguiente stateActual: ", stageName)
          let nextComponent = coreFunctions.GetLegoNext(stageName);
          coreFunctions.DoNextStage({
            navigate,
            nextComponent,
            State: { stageName, stageId, stage, folioId },
          });
        }
      }
    }
  }, [file]);

  useEffect(() => {
    if (cancelWF.items != undefined && cancelAction) {
      // console.log('cancelWF: ', cancelWF.items)
      if (goToDashboard == 1) {
        //TODO: Se implementa cuando exista dashboard
        // navigate('/auth/')
      } else if (performLogout == 1) {
        navigate("/auth/");
      } else if (logoutOnSave && logoutOnSave == "1") {
        //Logout y redireccion a login
        console.log("LogoutOnSave::clearsesion");
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate("/auth/");
          }
        );
      } else {
        navigate("/auth/");
      }
    }
  }, [cancelWF]);

  useEffect(() => {
    setLoadView(continueWF.loading);
    if (continueWF.items != undefined && continueAction) {
      // console.log('continueWF: ', continueWF.items)
      if (goToDashboard == 1 || goToDashboard == "1") {
        //navigate('/main/SearchResultComponent')
        navigate("/main/SearchResultComponent", {
          state: { forceReload: true },
        });
      } else if (performLogout == 1) {
        navigate("/auth/");
      } else if (logoutOnSave && logoutOnSave == "1") {
        //Logout y redireccion a login
        console.log("LogoutOnSave::clearsesion");
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate("/auth/");
          }
        );
      } else {
        let nextStage = continueWF.items.Stage;
        let stageName = nextStage.Name;
        let stageId = nextStage.Id;
        let folioId = location.state.folioId;
        let stage = continueWF.items;

        let nextComponent = coreFunctions.GetLegoNext(stageName);
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId },
        });
      }
    }
  }, [continueWF]);

  let handleContinue = () => {
    if (statusFileInfo == "Visita finalizada") {
      let stageCurrent = wf.items[0].Stages.find(
        (items) => items.Name == "Dashboard"
      );
      console.log("Stage current---------------: ", stageCurrent);
      let nextStage = stageCurrent;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let folioId = stageCurrent.Id;
      let stage = stageCurrent;
      let nextComponent = coreFunctions.GetLegoNext(stageName);
      console.log(
        "nextComponent nextComponent---------------: ",
        nextComponent
      );
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    } else {
      setContinueAction(true);
      let dataRequest = {
        File_Id: fileId,
      };
      dispatch(workflowActions.ContinueWorkflowAction(dataRequest));
    }
  };

  let handleCancel = () => {
    setShowAlertMaterial(true);
  };

  let handleAlerDialog = (pos) => {
    switch (pos) {
      case "left":
        setShowAlertMaterial(false);
        // console.log('Cancela modal')
        break;
      case "right":
        setCancelAction(true);
        dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }));
        break;
      default:
        break;
    }
    setShowAlertMaterial(false);
  };

  const getImageName = () => {
    if (
      titleText == "Validación de documentos" &&
      iconRefValue === "ic_informativo_vector.jpg"
    ) {
      return ic_informativo_vectorImg;
    } else if (iconRefValue === "ic_aceptacion.jpg") {
      return ic_aceptacionImg;
    } else if (
      statusFileInfo == "Visita finalizada" &&
      iconRefValue === "ic_payment_registration.jpg"
    ) {
      return ic_payment_registrationImg;
    } else if (statusFileInfo == "Visita finalizada") {
      return ic_register_validationImg;
    } else if (iconRefValue === "ic_registroNoEncontrado.jpg") {
      return ic_registroNoEncontradoImg;
    } else if (iconRefValue === "ic_nuevos_usuarios.jpg") {
      return ic_nuevos_usuariosImg;
    } else if (iconRefValue === "ic_registroEncontrado.jpg") {
      return ic_registroEncontradoImg;
    } else if (iconRefValue === "ic_person_conference.svg") {
      return ic_person_conferenceImg;
    } else if (iconRefValue === "ic_info_information.jpg") {
      return ic_informativo_vectorImg;
    } else if (iconRefValue === "ic_info_check_vendor.jpg") {
      return ic_informativo_vectorImg;
    } else return ic_informativo_vectorImg;
  };

  //Comienza interfaz
  return (
    <GenericContainer>
      {/* <Typography variant="h6"
            gutterBottom >{titleText}</Typography> */}
      <Typography variant="h6" color={"primary"} gutterBottom>
        {textDescription != undefined && textDescription != ""
          ? Parser(textDescription)
          : ""}
      </Typography>
      <GenericContainerForm>
        <GenericContainerImage>
          {iconRefValue != undefined &&
          iconRefValue != null &&
          iconRefValue != "" ? (
            <UseImage className={localStyles.imgHelp} src={getImageName()} />
          ) : null}
        </GenericContainerImage>
      </GenericContainerForm>
      {activaContinueButton == 1 ? (
        <Buttons
          ConfirmButtonText={
            statusFileInfo == "Visita finalizada" ? "Finalizar" : "Continuar"
          }
          onClickConfirm={handleContinue}
        />
      ) : null}
      {allowCancelFlow == 1 ? (
        <Buttons
          CancelButtonText={t("general_cancel")}
          onClickCancel={handleCancel}
        />
      ) : null}

      {loadView ? (
        <CustomLoadingOverlay
          active={loadView}
          text={t("general_loading_message")}
        />
      ) : null}
      <CustomAlertMaterial
        title={t("general_cancel")}
        body="Al rechazar, deberás comenzar el proceso para una nueva solicitud. ¿Estas seguro de rechazar?"
        leftButtonText={t("general_cancel")}
        closeAction={() => setShowAlertMaterial(false)}
        open={showAlertMaterial}
        leftButtonAction={() => handleAlerDialog("left")}
        rightButtonText={t("general_accept")}
        rightButtonAction={() => handleAlerDialog("right")}
      />
    </GenericContainer>
  );
}
